// extracted by mini-css-extract-plugin
export default {"htu_wrapper":"HowToUse_htu_wrapper__uqQhK","htu_content_wrapper":"HowToUse_htu_content_wrapper__ohYQU"};